var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconLandingPageN3G6Ahtvky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFEFE4;}\n\t.st2{fill:#69EBFC;}\n\t.st3{fill:#5FD4E3;}\n\t.st4{fill:#A1F1FC;}\n\t.st5{fill:#D476E2;}\n\t.st6{fill:#B665C2;}\n\t.st7{fill:#EA82FA;}\n\t.st8{fill:#FFF7F2;}\n\t.st9{fill:#FF8354;}\n\t.st10{fill:#FFA172;}\n\t.st11{fill:#6770E6;}\n\t.st12{fill:#5861C7;}\n\t.st13{fill:#E0734A;}\n\t.st14{fill:#EDD4C2;}\n\t.st15{fill:#CC6944;}\n\t.st16{fill:#858EFF;}\n\t.st17{fill:#C76642;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#FFDEC7;}\n\t.st20{fill:#4E56B0;}\n\t.st21{fill:#94529E;}\n\t.st22{fill:#41B6C5;}\n\t.st23{fill:#9847A4;}\n\t.st24{fill:#C2552C;}\n\t.st25{fill:#CFB6A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.935,256H26.065C11.67,256,0,244.33,0,229.935V26.065C0,11.67,11.67,0,26.065,0h203.87 C244.33,0,256,11.67,256,26.065v203.87C256,244.33,244.33,256,229.935,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M229.935,249H26.065C11.67,249,0,237.33,0,222.935v7C0,244.33,11.67,256,26.065,256h203.87 C244.33,256,256,244.33,256,229.935v-7C256,237.33,244.33,249,229.935,249z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.935,0H26.065C11.67,0,0,11.67,0,26.065V40h256V26.065C256,11.67,244.33,0,229.935,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.935,0H26.065C11.67,0,0,11.67,0,26.065v7C0,18.67,11.67,7,26.065,7h203.87C244.33,7,256,18.67,256,33.065 v-7C256,11.67,244.33,0,229.935,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 35,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 68.5,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 102,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.445,156.614H29.555c-1.963,0-3.555-1.592-3.555-3.555V62.982c0-1.963,1.592-3.555,3.555-3.555h196.89 c1.963,0,3.555,1.592,3.555,3.555v90.077C230,155.022,228.408,156.614,226.445,156.614z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st2",
    d: "M82.907,170.609H29.555c-1.963,0-3.555,1.592-3.555,3.555v40.728 c0,1.963,1.592,3.555,3.555,3.555h53.352c1.963,0,3.555-1.592,3.555-3.555v-40.728C86.462,172.2,84.87,170.609,82.907,170.609z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st5",
    d: "M154.643,170.609h-53.352c-1.963,0-3.555,1.592-3.555,3.555v40.728 c0,1.963,1.592,3.555,3.555,3.555h53.352c1.963,0,3.555-1.592,3.555-3.555v-40.728C158.198,172.2,156.607,170.609,154.643,170.609z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st11",
    d: "M226.38,170.609h-53.352c-1.963,0-3.555,1.592-3.555,3.555v40.728 c0,1.963,1.592,3.555,3.555,3.555h53.352c1.963,0,3.555-1.592,3.555-3.555v-40.728C229.935,172.2,228.343,170.609,226.38,170.609z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st14",
    d: "M79.798,236.573H32.663c-2.206,0-3.995-1.788-3.995-3.995l0,0c0-2.206,1.788-3.995,3.995-3.995 h47.135c2.206,0,3.995,1.788,3.995,3.995l0,0C83.793,234.785,82.004,236.573,79.798,236.573z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st14",
    d: "M151.535,236.573H104.4c-2.206,0-3.995-1.788-3.995-3.995l0,0c0-2.206,1.788-3.995,3.995-3.995 h47.135c2.206,0,3.995,1.788,3.995,3.995l0,0C155.53,234.785,153.741,236.573,151.535,236.573z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st14",
    d: "M223.272,236.573h-47.135c-2.206,0-3.995-1.788-3.995-3.995l0,0 c0-2.206,1.788-3.995,3.995-3.995h47.135c2.206,0,3.995,1.788,3.995,3.995l0,0C227.266,234.785,225.478,236.573,223.272,236.573z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.243,103.836l-29.655-17.121c-3.221-1.859-7.247,0.465-7.247,4.184v34.242 c0,3.719,4.026,6.043,7.247,4.184l29.655-17.121C150.464,110.345,150.464,105.696,147.243,103.836z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconLandingPageN3G6Ahtvky);
export default __webpack_public_path__ + "static/media/reshot-icon-landing-page-N3G6AHTVKY.e5b273db9f7aa6b50c78a4d652e6ce0e.svg";
export { ForwardRef as ReactComponent };